import styled, { css } from 'styled-components';

export interface CardBlockProps {
	flex?: string;
	showGuttersTop?: boolean;
	padding?: string;
}

/**
 * `CardBlock` is a basic building stone used inside a cards.
 *
 * A CardBlock contains the background seen in cards, padding and flexbox attributes.
 */
const CardBlock = styled.div<CardBlockProps>`
	display: flex;
	flex: ${({ flex = '1' }) => flex};

	${({ showGuttersTop = false }) =>
		showGuttersTop &&
		css`
			margin-top: 2px;
		`}

	padding: ${({ padding = '0 12px 12px 12px' }) => padding};
	font: var(--caption);
`;

export default CardBlock;
